// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { salesRepInformationStyles } from "@awc/App/Widgets/SalesRepInformation/SalesRepInformation";
import { css } from "styled-components";

salesRepInformationStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
    `,
};

salesRepInformationStyles.title = {
    variant: "h3",
    as: "h2",
    css: css`
        margin-top: 20px;
        margin-bottom: 4px;
    `,
};
salesRepInformationStyles.image = {
    width: "100px",
    height: "100px",
    css: css`
        margin-bottom: 6px;
    `,
};
